import React, { useState } from 'react';

import Menu from '~/components/core/Atomic/Menu';
import SkeletonLines from '~/components/core/Skeletons/SkeletonLines';

import { useClaim } from '../../../ClaimContainer';
import { FsMenuItem } from '../../../core';
import HoverActionField from '../../../HoverActionField';
import { ThreeDotsIcon } from '../../../icons';
import ExternalClaimNumber from '../../ExternalClaimNumber';

const claimNumberRowClass = 'flex items-center text-base font-semibold text-pink-600';

// The claim number's own row with a placeholder for the number, so the waiting bar is as tall as the
// loaded one: this row, with its action button, is the bar's tallest value. The button stays invisible
// until hovered, and the waiting strip takes no pointer.
export const ClaimNumberSkeletonValue = () => (
  <div className={claimNumberRowClass}>
    <SkeletonLines count={1} lineClassName="h-[1lh] w-[100px]" />
    <HoverActionField icon={ThreeDotsIcon} onAction={() => {}} ignorePermissions />
  </div>
);

const ClaimNumberContainer = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isExternalClaimNumberDialogOpen, setIsExternalClaimNumberDialogOpen] = useState(false);
  const { claim } = useClaim();

  const handleOpenExternalClaimNumberDialog = () => {
    setAnchorEl(null);
    setIsExternalClaimNumberDialogOpen(true);
  };

  return (
    <>
      <div className={claimNumberRowClass} data-testid="claim-number">
        {claim.claim_id_display}
        <>
          <HoverActionField
            icon={ThreeDotsIcon}
            onAction={(event) => setAnchorEl(event.currentTarget)}
            permanent={true}
            ignorePermissions
            tooltipTitle="Manage External Claim Numbers"
          />
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
            <FsMenuItem onClick={() => handleOpenExternalClaimNumberDialog()} disabled={false} ignorePermissions>
              Manage External Claim Numbers
            </FsMenuItem>
          </Menu>
        </>
      </div>
      {isExternalClaimNumberDialogOpen && (
        <ExternalClaimNumber onClose={() => setIsExternalClaimNumberDialogOpen(false)} />
      )}
    </>
  );
};

export default ClaimNumberContainer;
